// removed by extract-text-webpack-plugin
module.exports = {"root":"show-footer__root","container":"show-footer__container","content":"show-footer__content","onlineExclusivesContainer":"show-footer__onlineExclusivesContainer show-footer__container","moreLinksContainer":"show-footer__moreLinksContainer show-footer__container","onlineExclusives":"show-footer__onlineExclusives show-footer__content","moreLinks":"show-footer__moreLinks show-footer__content"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/containers/show-footer/styles.less
// module id = 501
// module chunks = 1